<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <div class="col-12">
                    <ValidationProvider name="user_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('user')">
                            <PersonsAutoComplete v-model="form.user_id"
                                                 :returnType="'id'"  :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('user_type')">
                            <parameter-selectbox code="microsoft_team_group_user_types" v-model="form.type" :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12">
                    <ValidationProvider name="role" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('roles')">
                            <parameter-selectbox code="microsoft_team_group_roles" v-model="form.role" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </b-row>
        </ValidationObserver>

        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import { ValidationProvider, ValidationObserver } from "vee-validate"
import MicrosoftTeamsGroupUsersServices from "@/services/MicrosoftTeamsGroupUsersServices";
import PersonsAutoComplete from "@/components/interactive-fields/PersonsAutoComplete.vue";

export default {
    components: {
        PersonsAutoComplete,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            formLoading: false,
            form: {},
        }
    },
    methods: {
        async createForm() {
            if (this.checkPermission('microsoftteamgroupuser_store')) {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.form.microsoft_team_group_id=this.$route.params.id
                    MicrosoftTeamsGroupUsersServices.store(this.form)
                        .then((response) => {
                            this.$toast.success(this.$t("api." + response.data.message));
                            this.$emit("createFormSuccess")
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        });
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>
